<template>
    <div class="records">
        <div class="records-table">
            <div class="table-title"><span>站点授权目录</span></div>
            <p class="record-total">您已经获得{{stationTotal}}个站点授权</p>
            <el-button class="insert" @click="linkToStation">提交新的申请</el-button>
            <el-table
                :data="authorizeData"
                stripe
                style="width: 100%">
                <el-table-column
                    prop="commName"
                    width="220"
                    label="运营商名称">
                </el-table-column>
                <el-table-column
                    prop="siteNumb"
                    label="本次站点授权数">
                </el-table-column>
                <el-table-column
                    prop="applyDate"
                    label="申请时间">
                </el-table-column>
                <el-table-column
                    prop="status"
                    label="状态">
                    <template slot-scope="scope">
                        <span>{{filter(scope.row.status)}}</span>
                        <img src="./images/success.png" v-if="scope.row.status == 1">
                        <img src="./images/warning.png" v-if="scope.row.status != 1">
                        <p>
                            <a v-if="scope.row.status == 1" @click="handleView(scope.$index, scope.row)">查看<span v-if="!scope.row.read"></span></a>
                            
                        </p>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                layout="prev, pager, next"
                @current-change="handleCurrentChangeStation"
                :current-page="stationCurrent"
                :page-size="stationSize"
                :total="stationTotal">
            </el-pagination>
        </div>
        <div class="cover" v-show="showRecords"></div>
        <div class="show-list" v-show="showRecords">
            <div class="close" @click="handelClose"><i class="el-icon-close"></i></div>
            <div class="title">站点列表</div>
            <el-table
                :data="records"
                stripe
                style="width: 776px; margin: 0 auto;">
                <el-table-column
                    prop="siteName"
                    label="站点名称">
                </el-table-column>
                <el-table-column
                    prop="deviceNumb"
                    label="设备数量">
                </el-table-column>
                <el-table-column
                    prop="chargerNumb"
                    label="插座数量">
                </el-table-column>
            </el-table>
            <el-pagination
                background
                layout="prev, pager, next"
                @current-change="handleCurrentChange"
                :current-page="current"
                :page-size="size"
                :total="total">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import {http, apiJson} from "@/utils/http"
import {Message} from 'element-ui'
export default {
    data () {
        return {
            authorizeData: [],
            records: [],
            total: 0,
            size: 10,
            current: 1,
            commid: '',
            applyId: '',
            showRecords: false,
            stationTotal: 0,
            stationSize: 10,
            stationCurrent: 1
        }
    },
    created () {
        let {params} = this.$route
        this.getCommercialSites(params.id)
    },
    mounted () {
        this.$store.dispatch('changeDefaultActive','records')
    },
    methods: {
        linkToStation () {
            let {params} = this.$route
            this.$router.push(`/create-app/${params.id}/station`)
        },
        getCommercialSites (appId) {
            let options = {
                appId: appId,
                current: this.stationCurrent,
                size: this.stationSize
            }
            http(apiJson.getApplyList, options).then(res => {
                if(res.code == 1) {
                    Message.warning(res.message)
                } else if(res.code == 0 && res.data.records && res.data.records.length > 0){
                    this.authorizeData = res.data.records
                    this.stationTotal = res.data.total
                }
            })
        },
        handleView (index, row) {
            this.commid = row.commid
            this.applyId = row.applyId
            this.current = 1
            this.getRecords(index)
        },
        handleCurrentChange (val) {
            this.current = val
            this.getRecords()
        },
        handleCurrentChangeStation (val) {
            this.stationCurrent = val
            let {params} = this.$route
            this.getCommercialSites(params.id)
        },
        countUnreadApply () {
            let {params} = this.$route
            http(`${apiJson.countUnreadApply}/${params.id}`).then(res => {
                if(res.code == 0) {
                    this.$store.dispatch('changeDataNum',res.data)
                }
            })
        },
        handelClose () {
            this.showRecords = false
        },
        getRecords (val) {
            // let {params} = this.$route
            let options = {
                commid: this.commid,
                applyId: this.applyId,
                current: this.current,
                size: this.size
            }
            http(apiJson.getCommercialSites, options).then(res => {
                if(res.code == 0 && res.data) {
                    this.records = res.data.records
                    this.total = res.data.total
                    this.showRecords = true
                }else {
                    Message.error(res.message)
                }
                if(val >= 0 && (res.code == 0 || res.message == '没有查询到授权站点数据')) {
                    console.log(val)
                    this.countUnreadApply()
                    this.authorizeData[val].read = 1
                }
            })
        }, 
        filter (val) {
            let tmp = {
                '0': '待处理',
                '1': '已通过',
                '2': '已拒绝'
            }
            return tmp[val] ? tmp[val] : '--'
        }
    }
}
</script>
<style lang="scss" scoped>
    .records {
        width: 100%;
        border-left: 1px solid #e5e5e5;
        height: 920px;
        .records-table {
            width: 776px;
            margin: 0 auto;
            .table-title {
                padding-bottom: 10px;
                width: 100%;
                font-size: 16px;
                color: #666666;
                font-weight: bold;
                margin: 60px 0 30px;
                border-bottom: 1px solid #e5e5e5;
                span {
                    padding-left: 14px;
                    border-left: 4px solid #3296fa;
                }
            }
            .records-total {
                line-height: 21px;
                margin-top: 20px;
                color: #666666;
                font-size: 16px;
            }
            .insert {
                float: right;
                margin-top: -21px;
                margin-bottom: 20px;
            }
            .el-table {
                border: 1px solid #ebeef5;
                text-align: center;
                & /deep/ .cell {
                    display: flex;
                    justify-content: space-around;
                    align-items:center;
                    text-align: center;
                    img {
                        width: 16px;
                        height: 16px;
                    }
                    p {
                        width: 24px;
                        height: 16px;
                        line-height: 16px;
                        a {
                            color: #3e81d0;
                            font-size: 12px;
                            line-height: 16px;
                            border-bottom: 1px solid #3e81d0;
                            cursor: pointer;
                            position: relative;
                            span {
                                width: 4px;
                                height: 4px;
                                border-radius: 5px;
                                display: inline-block;
                                background: #f56c6c;
                                position: absolute;
                            }
                        }
                        
                    }
                }
            }
        }
        .cover {
            width: 100%;
            height: 100%;
            background: #000000;
            opacity: 0.5;
            top: 0;
            left: 0;
            position: fixed;
            z-index: 9;
        }
        .show-list {
            width: 852px;
            background: #ffffff;
            border: 1px solid #979797;
            border-radius: 4px;
            position: fixed;
            padding-bottom: 30px;
            top: 50%;
            left: 50%;
            transform: translateX(-50%) translateY(-50%);
            z-index: 10;
            .close {
                padding: 30px;
                position: absolute;
                top: 0;
                right: 0;
                cursor: pointer;
            }
            .title {
                padding: 20px 0 30px 0;
                line-height: 21px;
                font-size: 16px;
                font-weight: bold;
                text-align: center;
            }
        }
        .el-pagination {
            margin-top: 20px;
            display: flex;
            justify-content: center;
        }
        .el-table {
            & /deep/ .cell {
                text-align: center;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/CreateApp/records.vue